import React from "react";
import { RegisterContextType } from "./types";

export const RegisterContext = React.createContext<
  RegisterContextType | undefined
>(undefined);
